import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { injectIntl, intlShape } from 'react-intl';
import size from 'lodash/size';

import * as utils from 'globals/utils';
import InputExpanding from 'shared/components/InputExpanding';
import * as keyboardEventHelpers from 'globals/keyboardEvents';
import ChatFormEnumButton from '../ChatFormEnumButton';
import ChatFormTreePicker from '../ChatFormTreePicker';
import ChatFormInputEnter from '../ChatFormInputEnter';

import ConversationInputStyles from '../../conversation/ChatConversationInput/styles';
import styles from './styles';
import messages from './messages';

class ChatFormInput extends React.PureComponent {
  state = {
    body: '',
  };

  _input = {
    focus: () => {},
  };

  handleKeyPress = e => {
    if (keyboardEventHelpers.isEnterKey(e)) {
      e.preventDefault();
      e.stopPropagation();
      this.handleSubmit();
    }
    return false;
  };

  handleChange = e => {
    this.setState({
      body: e.target.value,
    });
  };

  handleSubmit = () => {
    const { disabled } = this.props;
    const { body } = this.state;
    const cleanBody = utils.cleanBody(body);

    if (disabled || !cleanBody) return;

    this.props.onSubmit({ body: cleanBody });
    this.setState({ body: '' });

    if (utils.isMobile()) {
      this._input.blur();
    } else {
      this._input.focus();
    }
  };

  handleButtonClick = (value, displayName) => {
    this.props.onSubmit({ value, displayName });
  };

  renderValueSelect = () => {
    const { values } = this.props;
    if (!values || !values.length) return null;
    return (
      <div style={styles.btnContainer}>
        {values.map((data, i) => {
          return (
            <ChatFormEnumButton
              onClick={this.handleButtonClick}
              key={`${data.value}-${i}`}
              displayName={data.displayName}
              value={data.value}
              icon={data.icon}
            />
          );
        })}
      </div>
    );
  };

  renderInput = () => {
    const { values, error, isAfterHours, intl } = this.props;
    if (values && values.length) return null;
    return [
      <InputExpanding
        key="input-expanding"
        ref={c => (this._input = c)}
        placeholder={
          error ||
          (isAfterHours
            ? intl.formatMessage(messages.placeholder_afterHours)
            : intl.formatMessage(messages.placeholder_inHours))
        }
        onKeyPress={this.handleKeyPress}
        value={this.state.body}
        onChange={this.handleChange}
        tabIndex="0"
        error={error}
      />,
      <ChatFormInputEnter
        className="enterIcon kustomer-app-reply-input-enter-button"
        key="input-enter"
        onClick={this.handleSubmit}
        tabIndex="0"
      />,
    ];
  };

  renderMLLPicker = () => {
    const { property } = this.props;
    return (
      <div
        className="messageInputWrap kustomer-app-reply-input-option-prompt"
        style={ConversationInputStyles.wrapperMll}
      >
        <ChatFormTreePicker onSubmit={this.handleButtonClick} property={property} />
      </div>
    );
  };

  render() {
    const { error, values, isMLL } = this.props;

    if (isMLL) return this.renderMLLPicker();

    return (
      <div
        className="messageInputWrap kustomer-app-reply-input-option-prompt"
        style={[
          [size(values) ? ConversationInputStyles.wrapperTeam : ConversationInputStyles.wrapper],
          ConversationInputStyles[error ? 'hasError' : null],
        ]}
      >
        {this.renderInput()}
        {this.renderValueSelect()}
      </div>
    );
  }
}

ChatFormInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
  isAfterHours: PropTypes.bool,
  isMLL: PropTypes.bool,
  property: PropTypes.string,
  error: PropTypes.string,
  intl: intlShape.isRequired,
};

ChatFormInput.defaultProps = {
  values: null,
  error: null,
  isMLL: false,
  property: '',
};

export const RadiumComponent = Radium(ChatFormInput);

export const intlComponent = injectIntl(RadiumComponent, { withRef: true });

export default intlComponent;
